import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../GroupMembersList/__generated__/user.fragment.generated';
export type GroupDataFragment = { __typename?: 'CommunityGroup', id: string, uuid: string, name: string, description?: string | null, members: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null }> };

export const GroupDataFragmentDoc = gql`
    fragment GroupData on CommunityGroup {
  id
  uuid
  name
  description
  members {
    ...UserBasicInfo
  }
}
    ${UserBasicInfoFragmentDoc}`;